import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Controller, useForm } from "react-hook-form";
import { ToggleButton } from "primereact/togglebutton";

import Header from "../Header";
import TechnicianApp from "./TechnicianApp";

import { getFormErrorMessage } from "../../utils/getFormErrorMessage";
import { useGetAllTechniciansQuery } from "../../services/technician/technicianServices";
import { useGetAllOrdersForTechnicianQuery } from "../../services/operation/operationForTechnician";
import CustomerOrderTable from "../Orders/CustomerOrderTable";

const TechnicianAppContainer = () => {
  const [id, setId] = useState(null);
  // const [showOrders, setShowOrders] = useState(false);

  const dispatch = useDispatch();

  const { assignTechnician: assignTechnicianState } = useSelector(
    (state) => state.operation
  );

  const defaultValues = {
    technicianId: "",
  };

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({ defaultValues });

  const { data: techniciansData, isLoading: techniciansLoading } =
    useGetAllTechniciansQuery("TechniciansDetails", {
      refetchOnMountOrArgChange: true,
    });

  const {
    data: orderData,
    isLoading,
    error,
    refetch,
  } = useGetAllOrdersForTechnicianQuery(id, {
    refetchOnMountOrArgChange: true,
  });

  const onSubmit = (data) => {
    setId(data?.technicianId?.code);
  };

  return (
    <div className="py-4 pr-4">
      <div className="p-4 rounded-3xl min-h-[calc(100vh-50px)] bg-[#ffeded]">
        <div className="flex flex-col justify-between h-full">
          <Header title={"Technician Portal"} />
          <div className="w-full h-full rounded-2xl m-2 px-2">
            <div className="flex justify-between items-center w-full">
              <div className="flex-1">
                {/* {id && (
                  <div className="flex items-center gap-3">
                    <ToggleButton
                      checked={showOrders}
                      onChange={(e) => setShowOrders(e.value)}
                      onLabel="Hide Orders"
                      offLabel="Show Orders"
                      className="px-3 py-2 bg-[#c4e1d8] text-[#0D6047] border-none rounded-xl"
                    />
                    <span className="text-sm text-[#0D6047] font-medium">
                      {showOrders ? "Orders visible" : "Orders hidden"}
                    </span>
                  </div>
                )} */}
              </div>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="flex items-start justify-end gap-2 mt-4"
              >
                <Controller
                  name="technicianId"
                  control={control}
                  rules={{ required: "Technician is required." }}
                  render={({ field, fieldState }) => (
                    <div className="flex flex-col ">
                      <span>
                        <Dropdown
                          id={field.name}
                          value={field.value}
                          onChange={(e) => field.onChange(e.value)}
                          options={
                            techniciansData
                              ? techniciansData.data.map((technician) => ({
                                  name: technician.full_name,
                                  code: technician.id,
                                }))
                              : []
                          }
                          loading={techniciansLoading}
                          optionLabel="name"
                          className={`${classNames({
                            "p-invalid": fieldState.error,
                          })} w-full rounded-xl`}
                          placeholder="Select a Technician"
                        />
                      </span>
                      {errors?.length !== 0 &&
                        getFormErrorMessage(field.name, errors)}
                    </div>
                  )}
                />
                <Button
                  label={"Submit"}
                  className="bg-[#c4e1d8] text-[#0D6047] border-none rounded-xl"
                  type="submit"
                />
              </form>
            </div>
            {id ? (
              <div className="flex flex-col gap-20">
                <TechnicianApp id={id} />
                {/* {showOrders && (
                  <div className="border-8 border-[#3A5D4C] p-4">
                    <CustomerOrderTable
                      orderData={orderData?.data || []}
                      onAddOrder={() => {}}
                      customerId={id}
                      refetchOrders={refetch}
                      loading={isLoading}
                    />
                  </div>
                )} */}
              </div>
            ) : (
              <p className="text-center">Please select a technician</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnicianAppContainer;
